import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ReportService } from "../../../../core/services/report.service";
import { AppBaseComponent } from "@utils";
import { MessageService } from "@services";


@Component({
  selector: 'app-reports-ministerio',
  templateUrl: './reports-ministerio.component.html',
  styleUrls: ['./reports-ministerio.component.scss'],
})
export class ReportsMinisterioComponent extends AppBaseComponent implements OnInit {

  reportForm: FormGroup;
  constructor(private fb: FormBuilder,
    private reportService: ReportService,
    private popupAlert: MessageService,
    private popUpService: MessageService) {
    super();
  }

  ngOnInit(): void {
    this.reportForm = this.fb.group({
      idTipoPersona: ['', [Validators.required]],
      fechaInicial: ['', [Validators.required, super.dateValidator]],
      fechaFinal: ['', [Validators.required, super.dateValidator]]
    })
  }

  verificarFecha() {
    //Bloquea del calendario desplegable
    const datepicker1 = document.getElementById('fecha-inicial');
    const datepicker2 = document.getElementById('fecha-final');
    const today = new Date();
    let date = today.getDate() > 9 ? today.getDate() :
      `0${today.getDate()}`;
    let month = today.getMonth() > 9 ? today.getMonth() + 1 :
      `0${today.getMonth() + 1}`;
    let year = today.getFullYear();

    datepicker1.setAttribute('max', `${year}-${month}-${date}`);
    datepicker2.setAttribute('max', `${year}-${month}-${date}`);

  }

  generarReporte(): void {

    if (!this.reportForm.valid) {
      this.popupAlert.errorAlert(
        `Por favor, revise el formulario del reporte, hay datos invalidos y/o incompletos.`,
        4000
      );
      console.log("FORMULARIO PROCESADO");
      console.log(this.reportForm.value);
      console.log("ERRORES FORMULARIO");
      console.log(super.getAllErrors(this.reportForm));
      this.reportForm.markAllAsTouched();
      return;
    }

    const idTipoPersona = this.reportForm.get('idTipoPersona').value;
    const fechaInicial = this.reportForm.get('fechaInicial').value;
    const fechaFinal = this.reportForm.get('fechaFinal').value;

    if (fechaFinal < fechaInicial) {
      this.popUpService.errorAlert("La fecha final no puede ser menor a la fecha inicial", 3000)
      return;
    }

    console.log("INFORMACION A ENVIAR");
    console.log("IdTipoPersona enviado: ", idTipoPersona);
    console.log("fechaInicial enviado: ", fechaInicial);
    console.log("fechaFinal enviado: ", fechaFinal);

    this.reportService.getReportDataMinistry(idTipoPersona, fechaInicial, fechaFinal).subscribe(resp => {
      console.log("Respuesta del servicio", JSON.stringify(resp));
      this.downloadCSV(resp, idTipoPersona);
    }
    )
  }

  downloadCSV(datos: any, juridica: number) {
    console.log("🚀 ~ file: reports-solicitudes.component.ts:78 ~ ReportsSolicitudesComponent ~ downloadCSV ~ datos", JSON.stringify(datos));
    let element = document.createElement('a');
    let datatable = [];
    let opciones = {};

    if (datos && datos.length > 0) {
      for (let i in datos) {
        let tipo = '';

        let ob = {
          'Direccionterritorial': datos[i].direccionterritorial,
          'Resolucion': datos[i].resolucion,
          'fechaexpedicion': datos[i].fechaexpedicion,
          'Fecharenovacion': datos[i].fecharenovacion,
          'Nombre': datos[i].nombre,
          'Cedula': datos[i].numeroidentificacion,
          'tecnico': datos[i].tecnico,
          'Tecnologo': datos[i].tecnologo,
          'profso': datos[i].profso,
          'profesionmedico': datos[i].profesionmedico,
          'profesioningeniero': datos[i].profesioningeniero,
          'profesionpsicologo': datos[i].profesionpsicologo,
          'Profesionotro': datos[i].profesionpotro,
          'Especialista': datos[i].especialista,
          'Maestria': datos[i].maestria,
          'Doctorado': datos[i].namedoctorado,
          'Campoaccion': datos[i].camposcccion
        };
        datatable.push(ob);
      }
      let textoPlano = juridica == 1 ? 'Direccionterritorial;Resolucion;fechaexpedicion;Fecharenovacion;Nombre;Cedula;tecnico;Tecnologo;profso;profesionmedico;profesioningeniero;profesionpsicologo;Profesion otro;Especialista;Maestria;Doctorado;Campo de accion\n' : 'Direccionterritorial;Resolucion;fechaexpedicion;Fecharenovacion;Razon Social;Nit;tecnico;Tecnologo;profso;profesionmedico;profesioningeniero;profesionpsicologo;Profesion otro;Especialista;Maestria;Doctorado;Campo de accion\n';
      for (let inf in datatable) {
        textoPlano += datatable[inf]['Direccionterritorial'] + ';'
          + datatable[inf]['Resolucion'] + ';'
          + datatable[inf]['fechaexpedicion'] + ';'
          + datatable[inf]['Fecharenovacion'] + ';'
          + datatable[inf]['Nombre'] + ';'
          + datatable[inf]['Cedula'] + ';'
          + datatable[inf]['tecnico'] + ';'
          + datatable[inf]['Tecnologo'] + ';'
          + datatable[inf]['profso'] + ';'
          + datatable[inf]['profesionmedico'] + ';'
          + datatable[inf]['profesioningeniero'] + ';'
          + datatable[inf]['profesionpsicologo'] + ';'
          + datatable[inf]['Profesionotro'] + ';'
          + datatable[inf]['Especialista'] + ';'
          + datatable[inf]['Maestria'] + ';'
          + datatable[inf]['Doctorado'] + ';'
          + datatable[inf]['Campoaccion'] + ';'
          + '\n';
        console.log("🚀 ~ file: reports-solicitudes.component.ts:132 ~ ReportsSolicitudesComponent ~ downloadCSV ~ textoPlano", textoPlano);
      }

      // +datatable[inf]['Profesión otro']+';'
      //+datatable[inf]['Otro Servicio']

      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(textoPlano));
      let nombre = juridica == 2 ? 'reporte_ministerioPJ.csv' : 'reporte_ministerioPN.csv';
      element.setAttribute('download', nombre);
      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);

    }

  }

  downloadExcel(datos: any) {


    const ExportJsonExcel = require('js-export-excel');

    let datatable = [];
    let opciones = {};

    if (datos && datos.length > 0) {

      for (let i in datos) {
        let tipo = '';
        let ob = {
          'Identificador': datos[i].identificador,
          'Direccion Territorio': datos[i].direccionterritorial,
          'Resolucion': datos[i].resolucion,
          'Fecha Expedicion': datos[i].fechaexpedicion,
          'Fecha Renovacion': datos[i].fecharenovacion,
          'Nombre': datos[i].nombre,
          'Representante Legal': datos[i].representantelegalnombre,
          'Numero identificacion': datos[i].numeroidentificacion,
          'Codigo Verificacion persona Juridica': datos[i].codigoverifJuridica,
          'Tipo Documento': datos[i].tipodocumento,
          'Codigo Documento': datos[i].tipodocumentoCode,
          'Programa': datos[i].programa,
          'Titulo profesional': datos[i].tituloprofesion,
          'Tipo titulo': datos[i].tipotitulo,
          'Doctorado?': datos[i].namedoctorado
        }
        datatable.push(ob);
      }

      opciones = {
        fileName: 'reporteMinisterio',
        datas: [
          {
            sheetData: datatable,
            sheetName: 'Historial solicitudes',
            sheetFilter: ['Identificador',
              'Direccion Territorio',
              'Resolucion',
              'Fecha Expedicion',
              'Fecha Renovacion',
              'Nombre',
              'Representante Legal',
              'Numero identificacion',
              'Codigo Verificacion persona Juridica',
              'Tipo Documento',
              'Codigo Documento',
              'Programa',
              'Titulo profesional',
              'Tipo titulo',
              'Doctorado?'],
            sheetHeader: ['Identificador',
              'Direccion Territorio',
              'Resolucion',
              'Fecha Expedicion',
              'Fecha Renovacion',
              'Nombre',
              'Representante Legal',
              'Numero identificacion',
              'Codigo Verificacion persona Juridica',
              'Tipo Documento',
              'Codigo Documento',
              'Programa',
              'Titulo profesional',
              'Tipo titulo',
              'Doctorado?']
          }
        ]
      };


      let toExcel = new ExportJsonExcel(opciones);
      toExcel.saveExcel();
    }

  }

  getErrorMessage(field: string): string {
    let message;
    let campoObligatorio = "Es requerido";
    let fechaErronea = "La fecha no puede ser una fecha futura o superior a la de hoy";

    if(this.isTouchedField(this.reportForm, field))
    {
      if(this.reportForm?.get(field).hasError('required'))
      {
        message=campoObligatorio;
      }
      else if(this.reportForm?.get(field).hasError('invalidDate'))
      {
        message = fechaErronea;
      }
    }

    return message;
  }

}
